"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KeyTypes = exports.PopoverType = exports.PopoverBodyMode = void 0;
var PopoverBodyMode = {
  PREVIEW: 'preview',
  EDIT: 'edit'
};
exports.PopoverBodyMode = PopoverBodyMode;
var PopoverType = {
  INSERT: 'INSERT',
  EDIT: 'EDIT'
};
exports.PopoverType = PopoverType;
var KeyTypes = {
  ESCAPE: 'Escape',
  ENTER: 'Enter'
};
exports.KeyTypes = KeyTypes;